const GET_ARTICLES_STOCKS_REQUESTED = "GET_ARTICLES_STOCKS_REQUESTED";
const GET_ARTICLES_STOCKS_SUCCEEDED = "GET_ARTICLES_STOCKS_SUCCEEDED";
const GET_ARTICLES_STOCKS_FAILED = "GET_ARTICLES_STOCKS_FAILED";

export {
  GET_ARTICLES_STOCKS_REQUESTED, GET_ARTICLES_STOCKS_SUCCEEDED, GET_ARTICLES_STOCKS_FAILED
}
